module.exports = __webpack_public_path__ + "img/GehenSieVonMirRunter.314f28c3.jpg";